import React, { Fragment, useState } from 'react';

import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import { useSelector } from 'react-redux';

import RadioScore from '../RadioScore';
import SubViwer from './SubViewer';

import styles from '../../App.module.css';
import { newReview } from '../../lib/api';
import { useNavigate } from 'react-router-dom';

const ReviewSub = () => {

  let navigate = useNavigate();

  const [validated, setValidated] = useState( false );
  const [showViewer, setShowViewer] = useState( false );
  const [radio1Score, setRadio1Score] = useState( '0' );
  const [radio2Score, setRadio2Score] = useState( '0' );
  const [radio3Score, setRadio3Score] = useState( '0' );
  const [radio4Score, setRadio4Score] = useState( '0' );
  const [radio5Score, setRadio5Score] = useState( '0' );
  const [radio6Score, setRadio6Score] = useState( '0' );
  const [radio7Score, setRadio7Score] = useState( '0' );
  const [radio8Score, setRadio8Score] = useState( '0' );
  const [radio9Score, setRadio9Score] = useState( '0' );
  const [radio10Score, setRadio10Score] = useState( '0' );
  const [radio11Score, setRadio11Score] = useState( '0' );
  const [radio12Score, setRadio12Score] = useState( '0' );
  // eslint-disable-next-line no-unused-vars
  const [strengths, setStrengths] = useState( '' );
  // eslint-disable-next-line no-unused-vars
  const [weakness, setWeakness] = useState( '' );
  // eslint-disable-next-line no-unused-vars
  const [other, setOther] = useState( '' );

  const revId = useSelector( state => state.user.accountId );

  const revCategories = [
    { name: 'Important issue and is a priority area for APA/RAPID/NIDDK', state: radio1Score, setter: setRadio1Score },
    { name: 'Potential to lead to larger proposal (for PI - likelihood of future funding)', state: radio2Score, setter: setRadio2Score },
    { name: 'Study aims (clear, justified, important)', state: radio3Score, setter: setRadio3Score },
    { name: 'Study design and methods (clear, logical)', state: radio4Score, setter: setRadio4Score },
    { name: 'Statistical analysis (appropriate, clear, feasible)', state: radio5Score, setter: setRadio5Score },
    { name: 'Feasibility to complete within one year (timeline clear, project doable)', state: radio6Score, setter: setRadio6Score },
    { name: 'Innovation (novel, creative)', state: radio7Score, setter: setRadio7Score },
    { name: 'Reasonable budget (follows guidelines of RFP)', state: radio8Score, setter: setRadio8Score },
    { name: 'Chair/departmental commitment to applicant (chair\'s letter)', state: radio9Score, setter: setRadio9Score },
    { name: 'Quality of mentorship (mentor\'s letter of support; mentor has successful track record of mentoring; mentor\'s commitment to applicant, project, and providing needed resources)', state: radio10Score, setter: setRadio10Score },
    { name: 'Candidate\'s future potential for success and leadership', state: radio11Score, setter: setRadio11Score },
    { name: 'OVERALL RATING (use same scale of 1-5; not necessarily an average of #1-11)', state: radio12Score, setter: setRadio12Score }
  ];

  const handleSubmit = async ( e ) => {
    e.preventDefault();
    const form = e.currentTarget;
    if ( form.checkValidity() === false ) {
      console.log( 'invalid' );
      setValidated( true );
      e.stopPropagation();
    }
    else {
      console.log( `authenticated: reviewer id is ${revId}` );
      await sendReview();
      navigate( '/rnd1review' );

    }
  };

  const sendReview = async () => {
    try {
      console.log( 'This is where we send to api' );

      const body = [
        {
          name: 'apid',
          type: 'INTEGER',
          value: window.location.href.split( '/' ).at( -1 )
        },
        {
          name: 'revid',
          type: 'INTEGER',
          value: revId
        },
        {
          name: 'q1',
          type: 'INTEGER',
          value: radio1Score
        },
        {
          name: 'q2',
          type: 'INTEGER',
          value: radio2Score
        },
        {
          name: 'q3',
          type: 'INTEGER',
          value: radio3Score
        },
        {
          name: 'q4',
          type: 'INTEGER',
          value: radio4Score
        },
        {
          name: 'q5',
          type: 'INTEGER',
          value: radio5Score
        },
        {
          name: 'q6',
          type: 'INTEGER',
          value: radio6Score
        },
        {
          name: 'q7',
          type: 'INTEGER',
          value: radio7Score
        },
        {
          name: 'q8',
          type: 'INTEGER',
          value: radio8Score
        },
        {
          name: 'q9',
          type: 'INTEGER',
          value: radio9Score
        },
        {
          name: 'q10',
          type: 'INTEGER',
          value: radio10Score
        },
        {
          name: 'q11',
          type: 'TEXT',
          value: radio11Score
        },
        {
          name: 'q0',
          type: 'INTEGER',
          value: radio12Score
        },
        {
          name: 'q12',
          type: 'TEXT',
          value: strengths
        },
        {
          name: 'q13',
          type: 'TEXT',
          value: weakness
        },
        {
          name: 'q14',
          type: 'TEXT',
          value: other
        }
      ];
      const response = await newReview( body );
      console.log( response );
      return response;
    }
    catch ( err ) {
      console.log( 'error here' );
      console.error( err.message );
    }
  };

  return (
    <Fragment>
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <Card body className={styles.Card}>
          <Card.Title className={styles['page-header']}>Please Rate the Full Proposal:</Card.Title>
          <Button type="button" className={styles['btn-round']} onClick={() => setShowViewer( !showViewer )}>{showViewer ? ( 'Hide Application' ) : ( 'Show Application' )}</Button>
          {showViewer && <SubViwer />}

          <Card.Body>
            <Card body className={[styles.bl, styles.CardLvl2]}>
              <Card.Body className={styles['flex-wrapper']}>
                <Card.Text className={styles.revRadioLabel}>Please enter scores for each category based off of the following criteria:</Card.Text>
                <Card.Text className={styles.radioHeaderText}>Excellent (1)</Card.Text>
                <Card.Text className={styles.radioHeaderText}>Good (2)</Card.Text>
                <Card.Text className={styles.radioHeaderText}>OK (3)</Card.Text>
                <Card.Text className={styles.radioHeaderText}>Weak (4)</Card.Text>
                <Card.Text className={styles.radioHeaderText}>Unacceptable (5)</Card.Text>
              </Card.Body>
            </Card>
            {revCategories.map( ( cat, idx ) => (
              <Form.Group as={RadioScore} contolId={`validationRadio-${idx}`} key={idx} catName={cat.name} sta={cat.state} set={cat.setter} idx={`${idx}`} />
            ) )}
          </Card.Body>
        </Card>
        <Card className={styles['Card']}>
          <Form.Group as={Card} body  className={styles.CardLvl2} controlId="validateText1">
            <Form.Label as={Card.Title}>Please comment on the Strengths of the Full Proposal:</Form.Label>
            <Form.Control
              required
              type="text"
              aria-describedby="strengthHelp"
              onChange={e => setStrengths( e.target.value )}
            />
            <Form.Text id="strengthHelp" muted>
                        Enter strengths of the proposal to help with acceptance decisions.
            </Form.Text>
            <Form.Control.Feedback type="invalid">
                        Please enter strengths
            </Form.Control.Feedback>
          </Form.Group>
          <Card body  className={styles.CardLvl2}>
            <Form.Label as={Card.Title} htmlFor="proposalWeaknesses">Please comment on the Weaknesses of the Full Proposal:</Form.Label>
            <Form.Control
              required
              type="text"
              id="proposalWeaknesses"
              aria-describedby="weaknessHelp"
              onChange={e => setWeakness( e.target.value )}
            />
            <Form.Text id="weaknessHelp" muted>
                        Enter weaknesses of the proposal to help with acceptance decisions.
            </Form.Text>
            <Form.Control.Feedback type="invalid">
                        Please enter weaknesses
            </Form.Control.Feedback>
          </Card>
          <Card body  className={styles.CardLvl2}>
            <Form.Label as={Card.Title} htmlFor="proposalOther">Any other specific comments you would like to add?</Form.Label>
            <Form.Control
              id="proposalOther"
              type="text"
              aria-describedby="otherHelp"
              onChange={e => setOther( e.target.value )}
            />
            <Form.Text id="otherHelp" muted>
                        Enter other comments you have about the proposal to help with acceptance decisions.
            </Form.Text>
          </Card>
        </Card>
        <Card className={styles['Card']}>
          <Card body className={[styles['CardLvl2']]}>
            <Card.Body className={styles['flex-wrapper-between']}>
              <Card.Title>
                <strong>Please ensure that all required fields have been completed before submitting your review</strong>
              </Card.Title>
              <Button
                className={styles['btn-round']}
                type="submit"
                variant="secondary">
                                Submit
              </Button>
            </Card.Body>
          </Card>
        </Card>
      </Form>
    </Fragment>
  );
};

export default ReviewSub;